import React, { ReactElement, useContext } from 'react'
import Console from '@/components/Console'
import { Context } from '@/components/Context'
import axios from 'axios'

const StatsOverview = (): ReactElement => {
    const { proposalData } = useContext(Context)

    const mintHandler = async () => {
        const currentAccount = localStorage.getItem('account')

        const localSignature = localStorage.getItem(`account_signature_${currentAccount}`)

        if (proposalData?.length > 0) {
            console.log('Minting: ' + JSON.stringify(proposalData[0]?.art.id))
            try {
                const response = await axios.post('/mint-art/', {
                    account: currentAccount,
                    signature: localSignature,
                    id: proposalData[0]?.art.id,
                })
                const mintData = JSON.stringify(response.data)
                console.log('Minted: ' + mintData)
            } catch (error) {
                console.error('Error minting art:', error)
            }
        }
    }

    return (
        <div>
            <p>
                <button type="button" className="nav__button" onClick={mintHandler}>
                    Mint now
                </button>
            </p>
            <h4>Owners list+NFT&apos;s</h4>
            <h4>Visitor #</h4>
            <h4>Transactions</h4>
            <h4>Accounts/Daily Active accounts</h4>
            <h4># Art uploaded</h4>
            <Console />
        </div>
    )
}

export default StatsOverview
